import React from 'react';
import { map, size } from 'lodash';
import { useParams, useHistory, Link } from 'react-router-dom';
import { useGetUsers, useCreateRoom, useGameHasStarted } from '../hooks';
import { addCommand } from '../helpers/gameServer';
import { Button } from './Button';
import { PageContainer, Container, H1, H2 } from './Layout';
import { UserId } from '../containers/UserId';
import { UserName } from '../containers/UserName';

export const Lobby: React.FC = () => {
    const { userId } = UserId.useContainer();
    const { userName } = UserName.useContainer();
    const { id } = useParams();
    const history = useHistory();
    const { users } = useGetUsers(id);

    const { gameHasStarted } = useGameHasStarted(id);
    useCreateRoom(userId, userName, id);

    // If we have commands, it means the game has started already
    React.useEffect(() => {
        if (gameHasStarted) {
            history.replace(`/game/${id}`);
        }
    }, [id, history, gameHasStarted]);

    const handleClick = () => {
        addCommand(id, {
            action: 'split',
            userId,
            seed: new Date().getTime(),
        });
        history.replace(`/game/${id}`);
    };

    return (
        <PageContainer>
            <Container>
                <H1>Room: {id}</H1>
                <span>
                    <Link to="/">Join a different game</Link>
                </span>
                <div>
                    <H2>Users</H2>
                    {map(users, ({ userName }) => (
                        <p key={userName}>{userName}</p>
                    ))}
                </div>
                {!!size(users) && userId && (
                    <Button fullWidth={true} onClick={handleClick}>
                        Start
                    </Button>
                )}
            </Container>
        </PageContainer>
    );
};

